import React from 'react'

import nodeIsOrBelongsTo from '@function/nodeIsOrBelongsTo'

export default function onMultiSelectKeyDown ({ ...params })
{
	const { toggle_id, toggle_ref, setVisibility, PREFIX='##option-', e } = params;

	if (e.code === 'ArrowDown')
	{
		handleArrowKey('down');
	}
	else if (e.code === 'ArrowUp')
	{
		handleArrowKey('up');
	}
	else if (e.code === 'Escape')
	{
		setVisibility(false);

	// rend le focus au menu déroulant
		if (toggle_ref?.current) toggle_ref.current?.focus?.();
	}

	function handleArrowKey (direction)
	{
		const selection = document.activeElement;

	// l'effet par défaut sert à scroller dans le conteneur
	// ce qui peut sortir l'élément de la partie scrollée
	// si on l'enlève le scroll suit naturellement l'élément en focus
		e.preventDefault();

		if (!selection)
		{
			return selectOption(direction === 'down' ? 'first' : 'last',
				selection, direction
			);
		}

		if (isAnOptionSelected(selection))
		{
			return selectOption(direction === 'down' ? 'next' : 'previous',
				selection, direction
			);
		}

		if (isSelectSelected(selection))
		{
			return selectOption(direction === 'down' ? 'first' : 'last',
				selection, direction
			);
		}
	}

	function selectOption (name, selection, direction='down', _index)
	{
		const pattern = '[id^="' + toggle_id + PREFIX + '"]';

		const options = document.querySelectorAll(pattern);

	// no option to select
		if (options.length === 0) return;

		let to_select_index;

		if (name === 'last')
		{
			to_select_index = options.length-1;
		}
		else if (name === 'first')
		{
			to_select_index = 0;
		}
		else if (['next', 'previous'].includes(name))
		{
			const index = _index === undefined
			? parseInt(selection.getAttribute('data-option-index'))
			: _index;

			if (isNaN(index) || index < 0) return;

			if (name === 'previous' && index < 1) return;
			if (name === 'next' && index > options.length-2) return;

			to_select_index = name === 'previous'
			? index-1
			: name === 'next'
			? index+1
			: undefined;
		}
		else if (parseInt(name) == name)
		{
			to_select_index = parseInt(name);
		}

		const button_to_focus = options[to_select_index];

		if (to_select_index === undefined || isNaN(parseInt(to_select_index)))
		{
			return;
		}

		if (button_to_focus?.disabled && direction)
		{
			const new_name = direction === 'up'
			? 'previous'
			: 'next';

			const new_index = direction === 'up'
			? to_select_index-1
			: to_select_index+1;

		// pas d'option après
			if (new_index < 0 || new_index > options.length-1) return;

			return selectOption(new_name, selection, direction, to_select_index);
		}

		if (button_to_focus) button_to_focus.focus();
	}

	function isAnOptionSelected (selection)
	{
		return (selection.id || '').startsWith(toggle_id + PREFIX);
	}

	function isSelectSelected (selection)
	{
		if (!toggle_id || !selection) return false;

		const select = document.getElementById(toggle_id);

		if (!select) return;

		return nodeIsOrBelongsTo(selection, select);
	}
}